module.exports = __webpack_public_path__ + "media/images/patient-icons/patient-info-Icon-0ef8aa42208777dd543e16baea238fac.svg";